import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import EditOrganization from './editOrganization'
import DataGrid from '../../GenericComponents/DataGrid';
import { Column } from 'primereact/column';
import Spinner from 'react-bootstrap/Spinner'
import BaseService from '../../../services/BaseService';

const SearchResultContainer = (props) => {
  const [editOrganization, setEditOrganization] = useState(false);
  const [selectedOrgInfo, setSelectedOrgInfo] = useState([]);
  const { searchReq } = props;
  const [organizations, setOrganizations] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "center",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    setSelectedOrgInfo(row);
    setEditOrganization(row);
  }

  const getOrganizationsBySearchReq = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "searchOrganizations",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "searchCriteria": {
          "orgId": searchReq.orgId,
          "orgTypeCodeId": searchReq.orgTypeCodeId,
          "orgDivisionCodeId": searchReq.orgDivisionCodeId
        }
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setOrganizations(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }
  useEffect(() => {
     getOrganizationsBySearchReq();
    // eslint-disable-next-line
  }, [searchReq]);

  const columns = [{
    dataField: 'orgName',
    text: 'Organization Name',
    sort: true,
  }, {
    dataField: 'orgType',
    text: 'Organization Type',
    sort: true,
  }, {
    dataField: 'orgDivision',
    text: 'Organization Division',
    sort: true,
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditOrganization(false);
     getOrganizationsBySearchReq();
  }

  return (
    <>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <DataGrid
            title="Search Result:"
            dataSource={organizations}
            sortField='OrgName'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
            </DataGrid>
      </div>
      {editOrganization && <EditOrganization onModalClose={() => handleModalClose()} organizationInfo={selectedOrgInfo} />}
    </>
  )
}

export default SearchResultContainer
